<script>
  import conciliacaoProjetoServico from '../servico';
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';

  const SITUACOES = {
    ok: { texto: 'OK', classe: 'tb-sit-ok', icone: 'fa-check' },
    suspeito: { texto: 'Suspeito', classe: 'tb-sit-susp', icone: 'fa-exclamation-triangle' },
    pendente: { texto: 'Pendente', classe: 'tb-sit-pend', icone: 'fa-ban' },
    tarifado: { texto: 'Tarifado', classe: 'tb-sit-feito', icone: 'fa-lock' },
  };

  export default {
    components: { DatePicker },
    data() {
      return {
        carregando: true,
        gerando: false,
        erro: '',
        de: null,
        ate: null,
        ocultarTarifados: true,
        painel: null,
        marcados: {},
        expandidos: {},
        confirmando: false,
        mostrarSobras: false,
        requisicao: 0,
      };
    },
    computed: {
      linhas() { return (this.painel && this.painel.linhas) || []; },
      resumo() { return (this.painel && this.painel.resumo) || {}; },
      sobras() { return (this.painel && this.painel.extratoSemBordero) || []; },
      marcaveis() { return this.linhas.filter(l => this.marcavel(l)); },
      selecionadas() { return this.linhas.filter(l => this.marcados[l.idBordero]); },
      suspeitosSelecionados() { return this.selecionadas.filter(l => l.situacao === 'suspeito'); },
      totalSelecionado() { return this.selecionadas.reduce((t, l) => t + (+l.valorPrevisto || 0), 0); },
      lancamentosSelecionados() { return this.selecionadas.reduce((t, l) => t + (l.grupos || []).length, 0); },
      todosMarcados() { return this.marcaveis.length > 0 && this.marcaveis.every(l => this.marcados[l.idBordero]); },
      periodoTexto() {
        if (!this.painel) return '';
        const de = moment(this.painel.de, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const ate = moment(this.painel.ate, 'YYYY-MM-DD').format('DD/MM/YYYY');
        return de === ate ? 'pagamentos de ' + de : 'pagamentos de ' + de + ' a ' + ate;
      },
      diferencaExtrato() { return (+this.resumo.semParNoExtrato || 0) + (+this.resumo.extratoSemBordero || 0); },
    },
    mounted() {
      conciliacaoProjetoServico.diaUtilAnterior()
        .then(r => {
          const data = r && r.data ? moment(r.data, 'YYYY-MM-DD').toDate() : this.diaUtilAnteriorLocal();
          this.de = data;
          this.ate = data;
        })
        .catch(() => {
          this.de = this.diaUtilAnteriorLocal();
          this.ate = this.diaUtilAnteriorLocal();
        })
        .then(() => this.carregar());
    },
    methods: {
      diaUtilAnteriorLocal() {
        const d = moment().subtract(1, 'day');
        while (d.day() === 0 || d.day() === 6) d.subtract(1, 'day');
        return d.toDate();
      },
      iso(data) { return data ? moment(data).format('YYYY-MM-DD') : ''; },
      moeda(v) { return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
      numero(v) { return (+v || 0).toLocaleString('pt-BR'); },
      situacao(l) { return SITUACOES[l.situacao] || SITUACOES.ok; },
      marcavel(l) { return l.situacao === 'ok' || l.situacao === 'suspeito'; },
      detalheSituacao(l) {
        if (l.situacao === 'tarifado') return (l.tarifadoEm ? 'em ' + l.tarifadoEm : '') + (l.tarifadoPor ? ' por ' + l.tarifadoPor : '');
        if (l.situacao === 'pendente') {
          const projetos = (l.pendencias || []).filter(p => p.idProjeto).length;
          return projetos ? projetos + ' projeto(s) sem configuração' : (l.pendencias[0] || {}).texto || '';
        }
        if (l.situacao === 'suspeito') return (l.avisos || [])[0] || '';
        const grupos = l.grupos || [];
        return grupos.length && grupos.every(g => g.noExtrato) ? 'confere com o extrato' : '';
      },
      contaDebito(l) {
        const contas = [];
        (l.grupos || []).forEach(g => { if (contas.indexOf(g.descricaoConta) < 0) contas.push(g.descricaoConta); });
        if (!contas.length) return '—';
        return contas.length === 1 ? contas[0] : contas.length + ' contas';
      },
      carregar() {
        const n = ++this.requisicao;
        this.carregando = true;
        this.erro = '';
        conciliacaoProjetoServico.tarifasBordero(this.iso(this.de), this.iso(this.ate), this.ocultarTarifados)
          .then(painel => {
            if (n !== this.requisicao) return;
            this.painel = painel;
            this.de = moment(painel.de, 'YYYY-MM-DD').toDate();
            this.ate = moment(painel.ate, 'YYYY-MM-DD').toDate();
            const marcados = {};
            (painel.linhas || []).forEach(l => { marcados[l.idBordero] = l.situacao === 'ok'; });
            this.marcados = marcados;
            this.expandidos = {};
            this.carregando = false;
            this.$nextTick(() => { if (this.$refs.corpo) this.$refs.corpo.scrollTop = 0; });
          })
          .catch(res => {
            if (n !== this.requisicao) return;
            this.carregando = false;
            this.painel = null;
            this.erro = res && res.body && res.body.message ? res.body.message : 'Não foi possível carregar os borderôs do período.';
          });
      },
      alternar(l) {
        if (!this.marcavel(l)) return;
        this.$set(this.marcados, l.idBordero, !this.marcados[l.idBordero]);
      },
      marcarTodos() {
        const valor = !this.todosMarcados;
        const marcados = Object.assign({}, this.marcados);
        this.marcaveis.forEach(l => { marcados[l.idBordero] = valor; });
        this.marcados = marcados;
      },
      expandir(l) { this.$set(this.expandidos, l.idBordero, !this.expandidos[l.idBordero]); },
      exportar() {
        const num = v => (v === null || v === undefined ? '' : (+v).toFixed(2).replace('.', ','));
        const txt = v => '"' + ('' + (v === null || v === undefined ? '' : v)).replace(/"/g, '""') + '"';
        const cab = ['Borderô', 'Pagamento', 'Conta do borderô', 'TEDs', 'Lote', 'Conta de débito', 'Tarifa prevista', 'Histórico', 'Rateios', 'No extrato', 'Situação', 'Detalhe', 'Pendências / divergências', 'Marcado'];
        const linhas = [cab.map(txt).join(';')];
        this.linhas.forEach(l => {
          const obs = (l.pendencias || []).map(p => (p.idProjeto ? p.idProjeto + ' ' + p.projeto + ': ' : '') + p.texto).concat(l.avisos || []).join(' | ');
          const grupos = l.grupos && l.grupos.length ? l.grupos : [{}];
          grupos.forEach(g => {
            linhas.push([
              txt(l.idBordero), txt(l.dataPagamento), txt(l.contaBordero), txt(l.teds), txt(g.loteTexto || ''), txt(g.descricaoConta || ''),
              num(g.valor), txt(g.historico || ''), txt(g.rateios ? g.rateios.length : ''),
              txt(l.situacao === 'tarifado' || !g.lote ? '' : (g.noExtrato ? 'sim' : 'não')),
              txt(this.situacao(l).texto), txt(this.detalheSituacao(l)), txt(obs), txt(this.marcados[l.idBordero] ? 'sim' : ''),
            ].join(';'));
          });
        });
        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'tarifas-bordero-' + moment(this.de).format('DD-MM-YYYY') + (this.iso(this.de) !== this.iso(this.ate) ? '-a-' + moment(this.ate).format('DD-MM-YYYY') : '') + '.csv';
        link.click();
        URL.revokeObjectURL(url);
      },
      gerar() {
        if (!this.selecionadas.length) { toastr.warning('Marque pelo menos um borderô.'); return; }
        if (this.suspeitosSelecionados.length) { this.confirmando = true; return; }
        this.confirmarGeracao();
      },
      confirmarGeracao() {
        this.confirmando = false;
        this.gerando = true;
        const payload = { borderos: this.selecionadas.map(l => l.idBordero), de: this.iso(this.de), ate: this.iso(this.ate) };
        conciliacaoProjetoServico.gerarTarifasBordero(payload)
          .then(r => {
            this.gerando = false;
            if (r.lancamentos > 0) {
              toastr.success('Borderôs tarifados: ' + this.numero(r.borderos) + ' · Lançamentos gerados: ' + this.numero(r.lancamentos)
                + ' · Valor total: R$ ' + this.moeda(r.valor));
            }
            if (r.pulados && r.pulados.length) {
              toastr.warning(r.pulados.length + ' borderô(s) não gerado(s): ' + r.pulados.map(p => p.idBordero + ' (' + p.motivo + ')').join(', '));
            }
            if (r.lancamentos > 0) this.$emit('gerado');
            this.carregar();
          })
          .catch(res => {
            this.gerando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível gerar as tarifas.');
          });
      },
    },
  };
</script>

<template>
  <div class="tb-ov">
    <div class="tb-modal">
      <div class="tb-head">
        <h4>Tarifas de pagamento por borderô</h4>
        <small>Uma tarifa por borderô de pagamento eletrônico, calculada pelos TEDs/DOCs para outros bancos e conferida contra o extrato antes de lançar.</small>
      </div>

      <div class="tb-filtros">
        <div class="tb-filtro">
          <label class="tb-lbl">Data de pagamento</label>
          <div class="tb-periodo">
            <span class="tb-dt-box">
              <date-picker v-model="de" format="DD/MM/YYYY" lang="pt-br" input-class="form-control input-sm tb-dt"
                           :editable="true" :shortcuts="false" :clearable="false" :append-to-body="true"
                           :popup-style="{ zIndex: 3200 }" @change="carregar"></date-picker>
            </span>
            <span class="tb-a">a</span>
            <span class="tb-dt-box">
              <date-picker v-model="ate" format="DD/MM/YYYY" lang="pt-br" input-class="form-control input-sm tb-dt"
                           :editable="true" :shortcuts="false" :clearable="false" :append-to-body="true"
                           :popup-style="{ zIndex: 3200 }" @change="carregar"></date-picker>
            </span>
          </div>
        </div>
        <label class="tb-chk" :class="{ on: ocultarTarifados }">
          <input type="checkbox" v-model="ocultarTarifados" @change="carregar"> Ocultar borderôs já tarifados
        </label>
        <span class="tb-periodo-txt" v-if="painel"><i v-if="carregando" class="fa fa-spinner fa-pulse"></i> {{ periodoTexto }}</span>
      </div>

      <div v-if="painel && !carregando" class="tb-cards">
        <div class="tb-card">
          <div class="tb-card-lbl">Borderôs</div>
          <div class="tb-card-num">{{ numero(resumo.borderos) }}</div>
          <div class="tb-card-obs">{{ numero(resumo.ok) }} OK · {{ numero(resumo.suspeitos) }} suspeito(s) · {{ numero(resumo.pendentes) }} pendente(s)<template v-if="!ocultarTarifados"> · {{ numero(resumo.tarifados) }} tarifado(s)</template></div>
        </div>
        <div class="tb-card">
          <div class="tb-card-lbl">Previsto</div>
          <div class="tb-card-num mono">{{ moeda(resumo.previstoValor) }}</div>
          <div class="tb-card-obs">{{ numero(resumo.previstoLinhas) }} lançamento(s) a gerar</div>
        </div>
        <div class="tb-card" :class="resumo.previstoLinhas && resumo.extratoCasadas === resumo.previstoLinhas ? 'tb-card-ok' : ''">
          <div class="tb-card-lbl">No extrato</div>
          <div class="tb-card-num mono">{{ moeda(resumo.extratoValorCasado) }}</div>
          <div class="tb-card-obs">{{ numero(resumo.extratoCasadas) }} de {{ numero(resumo.previstoLinhas) }} com linha de débito igual na conta de débito</div>
        </div>
        <div class="tb-card" :class="resumo.semParNoExtrato ? 'tb-card-alerta' : ''">
          <div class="tb-card-lbl">Sem par no extrato</div>
          <div class="tb-card-num mono">{{ moeda(resumo.semParValor) }}</div>
          <div class="tb-card-obs">{{ numero(resumo.semParNoExtrato) }} tarifa(s) prevista(s) sem linha no extrato</div>
        </div>
        <div class="tb-card tb-card-click" :class="resumo.extratoSemBordero ? 'tb-card-alerta' : ''" @click="mostrarSobras = !mostrarSobras" :title="sobras.length ? 'Clique para ver as linhas' : ''">
          <div class="tb-card-lbl">Extrato sem borderô <i v-if="sobras.length" class="fa" :class="mostrarSobras ? 'fa-caret-up' : 'fa-caret-down'"></i></div>
          <div class="tb-card-num mono">{{ moeda(resumo.extratoSemBorderoValor) }}</div>
          <div class="tb-card-obs">{{ numero(resumo.extratoSemBordero) }} tarifa(s) cobrada(s) pelo banco sem borderô previsto</div>
        </div>
      </div>

      <div v-if="mostrarSobras && sobras.length" class="tb-sobras">
        <div class="tb-sobras-tit">Débitos de tarifa de pagamento no extrato que não casaram com nenhum borderô</div>
        <table class="tb-tab tb-tab-sobras">
          <thead><tr><th>Data</th><th>Conta</th><th>Histórico</th><th class="r">Valor</th></tr></thead>
          <tbody>
            <tr v-for="s in sobras" :key="s.idExtrato">
              <td class="mono">{{ s.data }}</td>
              <td>{{ s.descricaoConta }}</td>
              <td class="hist" :title="s.historico">{{ s.historico }}</td>
              <td class="r mono deb">{{ moeda(s.valor) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tb-corpo" ref="corpo">
        <div v-if="carregando" class="tb-msg"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
        <div v-else-if="erro" class="tb-msg tb-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <div v-else-if="!linhas.length" class="tb-msg">Nenhum borderô de pagamento eletrônico com TED/DOC para outro banco {{ ocultarTarifados ? 'pendente de tarifa ' : '' }}no período.</div>
        <table v-else class="tb-tab">
          <thead>
            <tr>
              <th class="c"><input type="checkbox" :checked="todosMarcados" :disabled="!marcaveis.length" @change="marcarTodos" title="Marcar todos os borderôs marcáveis"></th>
              <th>Borderô</th>
              <th>Pagamento</th>
              <th>Conta do borderô</th>
              <th class="r">TEDs</th>
              <th>Lotes</th>
              <th class="r">Tarifa prevista</th>
              <th>Conta de débito</th>
              <th>Situação</th>
              <th class="c"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="l in linhas">
              <tr :key="l.idBordero" :class="['tb-linha', 'tb-' + l.situacao, { sel: marcados[l.idBordero], aberta: expandidos[l.idBordero] }]" @click="alternar(l)">
                <td class="c" @click.stop>
                  <input type="checkbox" :checked="!!marcados[l.idBordero]" :disabled="!marcavel(l)" @change="alternar(l)">
                </td>
                <td class="mono b">{{ l.idBordero }}</td>
                <td class="mono">{{ l.dataPagamento || '—' }}</td>
                <td class="hist" :title="l.contaBordero">{{ l.contaBordero }}</td>
                <td class="r mono">{{ numero(l.teds) }}</td>
                <td>{{ l.lotes || '—' }}</td>
                <td class="r mono b">{{ moeda(l.valorPrevisto) }}</td>
                <td class="hist" :title="contaDebito(l)">{{ contaDebito(l) }}</td>
                <td>
                  <span class="tb-sit" :class="situacao(l).classe"><i class="fa" :class="situacao(l).icone"></i> {{ situacao(l).texto }}</span>
                  <small class="tb-sit-det" :title="detalheSituacao(l)">{{ detalheSituacao(l) }}</small>
                </td>
                <td class="c" @click.stop>
                  <button type="button" class="tb-exp" :title="expandidos[l.idBordero] ? 'Recolher' : 'Ver detalhes'" @click="expandir(l)"><i class="fa" :class="expandidos[l.idBordero] ? 'fa-chevron-up' : 'fa-chevron-down'"></i></button>
                </td>
              </tr>
              <tr v-if="expandidos[l.idBordero]" :key="l.idBordero + '-det'" class="tb-det">
                <td colspan="10">
                  <div class="tb-det-grid">
                    <div class="tb-det-bloco" v-if="l.pendencias && l.pendencias.length">
                      <div class="tb-det-tit tb-det-tit-pend"><i class="fa fa-ban"></i> Pendências de cadastro (impedem a geração)</div>
                      <div v-for="(p, i) in l.pendencias" :key="'p' + i" class="tb-det-item">
                        <b v-if="p.idProjeto">{{ p.idProjeto }} · {{ p.projeto }}</b>
                        <span>{{ p.texto }}</span>
                      </div>
                    </div>
                    <div class="tb-det-bloco" v-if="l.avisos && l.avisos.length">
                      <div class="tb-det-tit tb-det-tit-susp"><i class="fa fa-exclamation-triangle"></i> Divergências com o extrato (não impedem)</div>
                      <div v-for="(a, i) in l.avisos" :key="'a' + i" class="tb-det-item"><span>{{ a }}</span></div>
                    </div>
                    <div class="tb-det-bloco" v-if="l.grupos && l.grupos.length">
                      <div class="tb-det-tit"><i class="fa fa-list"></i> Lançamentos que serão gerados</div>
                      <table class="tb-tab tb-tab-det">
                        <thead><tr><th>Conta de débito</th><th>Lote</th><th>Histórico</th><th class="r">Valor</th><th class="r">Rateios</th><th class="c">Extrato</th></tr></thead>
                        <tbody>
                          <tr v-for="(g, i) in l.grupos" :key="'g' + i">
                            <td>{{ g.descricaoConta }}</td>
                            <td>{{ g.loteTexto }}</td>
                            <td class="hist" :title="g.historico">{{ g.historico }}</td>
                            <td class="r mono">{{ moeda(g.valor) }}</td>
                            <td class="r mono">{{ numero((g.rateios || []).length) }}</td>
                            <td class="c"><i v-if="l.situacao === 'tarifado'" class="fa fa-minus mudo"></i><i v-else-if="g.noExtrato" class="fa fa-check ok" title="Há débito igual no extrato da conta de débito"></i><i v-else class="fa fa-times ruim" title="Nenhum débito igual no extrato da conta de débito"></i></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="tb-foot">
        <div class="tb-foot-info">
          <template v-if="selecionadas.length">
            {{ numero(selecionadas.length) }} borderô(s) marcado(s) · {{ numero(lancamentosSelecionados) }} lançamento(s) · R$ {{ moeda(totalSelecionado) }}
            <span v-if="suspeitosSelecionados.length" class="tb-foot-susp"><i class="fa fa-exclamation-triangle"></i> {{ suspeitosSelecionados.length }} suspeito(s) na seleção</span>
          </template>
          <template v-else-if="painel && !carregando">Nenhum borderô marcado.</template>
        </div>
        <div class="tb-acoes">
          <button type="button" class="btn btn-primary" :disabled="carregando || !linhas.length" @click="exportar"><i class="fa fa-file-excel-o"></i> Exportar Excel</button>
          <button type="button" class="btn btn-success" :disabled="gerando || carregando || !selecionadas.length" @click="gerar">
            <i class="fa" :class="gerando ? 'fa-spinner fa-pulse' : 'fa-money'"></i> {{ gerando ? 'Gerando...' : 'Gerar tarifas (' + selecionadas.length + ')' }}
          </button>
          <button type="button" class="btn rd-sair" :disabled="gerando" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>

      <div v-if="confirmando" class="tb-conf-ov">
        <div class="tb-conf">
          <h5><i class="fa fa-exclamation-triangle"></i> Borderôs com divergência na seleção</h5>
          <p>As divergências abaixo não foram corrigidas. As tarifas serão geradas assim mesmo e podem não corresponder ao que o banco cobrou.</p>
          <ul class="tb-conf-lista">
            <li v-for="l in suspeitosSelecionados" :key="'c' + l.idBordero"><b class="mono">{{ l.idBordero }}</b> · {{ l.contaBordero }} · R$ {{ moeda(l.valorPrevisto) }}<small>{{ (l.avisos || []).join(' · ') }}</small></li>
          </ul>
          <p class="tb-conf-perg">Confirma a geração dos {{ selecionadas.length }} borderôs marcados?</p>
          <div class="tb-conf-acoes">
            <button type="button" class="btn btn-primary" @click="confirmarGeracao"><i class="fa fa-money"></i> Gerar assim mesmo</button>
            <button type="button" class="btn rd-sair" @click="confirmando = false"><i class="fa fa-sign-out"></i> Voltar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .tb-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 2100; display: flex; align-items: center; justify-content: center; }
  .tb-modal { position: relative; width: 1360px; max-width: 97vw; height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 16px 48px rgba(16,24,40,.35); overflow: hidden; }
  .tb-head { flex: 0 0 auto; padding: 14px 18px 10px; border-bottom: 1px solid #eceef1; }
  .tb-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .tb-head small { display: block; color: #8a939c; font-size: 12px; margin-top: 3px; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }
  .mudo { color: #b3b9c0; }
  .ok { color: #0a6d4d; }
  .ruim { color: #c0392b; }
  .deb { color: #c0392b; }

  .tb-filtros { flex: 0 0 auto; display: flex; align-items: flex-end; flex-wrap: wrap; gap: 8px 16px; padding: 10px 18px; border-bottom: 1px solid #eceef1; background: #fbfcfd; }
  .tb-filtro { display: flex; flex-direction: column; gap: 4px; }
  .tb-lbl { font-size: 11px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; margin: 0; }
  .tb-periodo { display: flex; align-items: center; gap: 6px; }
  .tb-a { color: #8a939c; font-size: 12px; }
  .tb-dt-box { display: inline-block; flex: 0 0 122px; width: 122px; }
  .tb-dt-box >>> .mx-datepicker { width: 100% !important; }
  .tb-dt-box >>> .tb-dt { height: 30px; font-size: 12.5px; padding: 4px 8px; }
  .tb-chk { display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 10px; margin: 0; border: 1px solid #c6ccd4; border-radius: 5px; background: #fff; font-size: 12px; font-weight: 400; color: #3b444d; cursor: pointer; user-select: none; }
  .tb-chk input { margin: 0; }
  .tb-chk.on { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; font-weight: 600; }
  .tb-periodo-txt { font-size: 12px; color: #6b747e; margin-left: auto; align-self: center; }

  .tb-cards { flex: 0 0 auto; display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; padding: 10px 18px; border-bottom: 1px solid #eceef1; }
  .tb-card { border: 1px solid #e3e7eb; border-radius: 6px; padding: 8px 12px; background: #fff; min-width: 0; }
  .tb-card-click { cursor: pointer; }
  .tb-card-alerta { border-color: #e0a83a; background: #fdf9ef; }
  .tb-card-lbl { font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; white-space: nowrap; }
  .tb-card-num { font-size: 18px; font-weight: 600; color: #1c2024; margin-top: 2px; }
  .tb-card-alerta .tb-card-num { color: #b06a15; }
  .tb-card-ok .tb-card-num { color: #0a6d4d; }
  .tb-card-obs { font-size: 11px; color: #8a939c; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .tb-sobras { flex: 0 0 auto; max-height: 26vh; overflow: auto; border-bottom: 1px solid #eceef1; background: #fdf9ef; }
  .tb-sobras-tit { padding: 8px 18px 4px; font-size: 11px; text-transform: uppercase; letter-spacing: .05em; color: #8a5a00; font-weight: 600; }
  .tb-tab-sobras th { background: #fdf3e0 !important; }

  .tb-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; }
  .tb-msg { text-align: center; padding: 40px; color: #8a939c; }
  .tb-erro { color: #a13c3c; }
  .tb-tab { width: 100%; border-collapse: collapse; }
  .tb-tab th { position: sticky; top: 0; z-index: 1; background: #f7f9fa; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; text-align: left; padding: 7px 10px; border-bottom: 1px solid #dfe3e8; white-space: nowrap; }
  .tb-tab th.r, .tb-tab td.r { text-align: right; }
  .tb-tab th.c, .tb-tab td.c { text-align: center; width: 36px; }
  .tb-tab td { font-size: 12.5px; color: #34495e; padding: 6px 10px; border-top: 1px solid #f0f1f3; white-space: nowrap; vertical-align: middle; }
  .tb-tab td.b { font-weight: 600; color: #1c2024; }
  .tb-tab td.hist { max-width: 220px; overflow: hidden; text-overflow: ellipsis; }
  .tb-tab input[type=checkbox] { margin: 0; width: 14px; height: 14px; }
  .tb-linha { cursor: pointer; }
  .tb-tab tbody tr.tb-linha:nth-child(even) > td { background: #fbfcfd; }
  .tb-linha:hover > td { background: #eaf5ff; }
  .tb-linha.tb-pendente, .tb-linha.tb-tarifado { cursor: default; }
  .tb-linha.tb-tarifado > td { color: #9aa3ac; }
  .tb-linha.aberta > td { border-bottom: none; }

  .tb-sit { display: inline-flex; align-items: center; gap: 4px; font-size: 10.5px; font-weight: 600; border-radius: 10px; padding: 1px 8px; line-height: 16px; border: 1px solid transparent; }
  .tb-sit-ok { color: #0a6d4d; background: #fff; border-color: #b9dccd; }
  .tb-sit-susp { color: #8a5a00; background: #fdf3e0; border-color: #f0d9a8; }
  .tb-sit-pend { color: #a13c3c; background: #fdf1f1; border-color: #e4d7d7; }
  .tb-sit-feito { color: #5b6570; background: #f1f3f5; border-color: #dfe3e8; }
  .tb-sit-det { display: block; font-size: 11px; color: #8a939c; margin-top: 2px; max-width: 260px; overflow: hidden; text-overflow: ellipsis; }
  .tb-exp { border: 1px solid #dfe3e8; background: #fff; border-radius: 4px; width: 24px; height: 24px; color: #6b747e; cursor: pointer; padding: 0; }
  .tb-exp:hover { background: #f4f6f8; color: #1c2024; }

  .tb-det > td { background: #fbfcfd; padding: 10px 18px 12px 46px; white-space: normal; border-top: none; }
  .tb-det-grid { display: flex; flex-direction: column; gap: 10px; }
  .tb-det-bloco { border: 1px solid #e3e7eb; border-radius: 6px; background: #fff; padding: 8px 12px; }
  .tb-det-tit { font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; margin-bottom: 6px; }
  .tb-det-tit-pend { color: #a13c3c; }
  .tb-det-tit-susp { color: #8a5a00; }
  .tb-det-item { display: flex; gap: 10px; font-size: 12.5px; color: #34495e; padding: 3px 0; border-top: 1px solid #f0f1f3; }
  .tb-det-item:first-of-type { border-top: none; }
  .tb-det-item b { flex: 0 0 auto; color: #1c2024; font-weight: 600; }
  .tb-tab-det th { position: static; background: #f7f9fa; }
  .tb-tab-det td { padding: 5px 10px; }

  .tb-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 12px 18px; border-top: 1px solid #dfe3e8; background: #f7f9fa; }
  .tb-foot-info { font-size: 13px; color: #5b6570; }
  .tb-foot-susp { margin-left: 10px; color: #8a5a00; font-weight: 600; }
  .tb-acoes { display: flex; gap: 8px; }
  .rd-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }

  .tb-conf-ov { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); display: flex; align-items: center; justify-content: center; z-index: 5; }
  .tb-conf { width: 620px; max-width: 94%; max-height: 80%; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 12px 36px rgba(16,24,40,.3); padding: 16px 18px; }
  .tb-conf h5 { margin: 0 0 8px; font-size: 15px; font-weight: 600; color: #8a5a00; }
  .tb-conf p { font-size: 13px; color: #34495e; margin: 0 0 8px; }
  .tb-conf-lista { flex: 1 1 auto; min-height: 0; overflow: auto; list-style: none; margin: 0 0 10px; padding: 0; border: 1px solid #eceef1; border-radius: 6px; }
  .tb-conf-lista li { padding: 6px 10px; font-size: 12.5px; color: #34495e; border-top: 1px solid #f0f1f3; }
  .tb-conf-lista li:first-child { border-top: none; }
  .tb-conf-lista li small { display: block; color: #8a5a00; font-size: 11.5px; margin-top: 2px; }
  .tb-conf-perg { font-weight: 600; color: #1c2024; }
  .tb-conf-acoes { display: flex; justify-content: flex-end; gap: 8px; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/TarifasBorderoModal.vue